import { uploadMediaObject } from '@/services/media'
import { Post as ServicePost, Tariff } from '@/services/types'
import { Commit } from 'vuex'
import { BuilderSetProfilePostsActionPayload, Post, Subscription } from './types'

export const setInitialBuilderState = (commit: Commit): void => {
  commit('setApp', null)
  commit('setProfile', {})
}

export const mapTariff = (source: Tariff): Subscription => ({
  id: source.id,
  name: source.name,
  price: String(source.amount),
  frequency: source.period,
  duration: source.type,
})

export const mapSubscription = (source: Subscription): Tariff => ({
  id: source.id,
  name: source.name,
  amount: Number(source.price),
  type: source.frequency,
  period: source.duration,
})

export const mapPost = (source: ServicePost): Post => ({
  id: source.id,
  attachments: source.attachments,
  title: '',
  text: source.body,
  subscriptions: source.tariffs.map(mapTariff),
  comments: source.comments ? true: false,
  promotional_page_id: source.promotional_page_id || undefined
})

export const uploadPostAttachments = async ({
  posts,
}: BuilderSetProfilePostsActionPayload): Promise<Record<number, number[]>> => {
  const attachments = await Promise.all(
    posts.map(async (post) => ({
      id: post.id,
      attachments: await Promise.all(
        post.attachments.map(async (attachment) => {
          if (attachment instanceof File) {
            const mediaObject = await uploadMediaObject(attachment)

            return mediaObject.id
          }

          return attachment
        })
      ),
    }))
  )

  return attachments.reduce((agg, cur) => ({ ...agg, [cur.id]: cur.attachments }), {})
}
